import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './styles.css';
import './assets/survey-form-controls.css';
import { loadRuntimeConfig } from './composables/runtime-config';

async function bootstrap(): Promise<void> {
  await loadRuntimeConfig();
  const app = createApp(App);
  app.use(router);
  await router.isReady();
  app.mount('#app');
}

void bootstrap();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  const registerServiceWorker = () => navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  if (document.readyState === 'complete') void registerServiceWorker();
  else window.addEventListener('load', registerServiceWorker, { once: true });
}
